import { motion } from 'framer-motion'
import React, { useState } from 'react'
import HarmonicaItem from '../molecules/HarmonicaItem'

const M12Harmonica = ({ heading, items, anchorLinkId }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  const handleToggle = toggleIndex =>
    setActiveIndex(toggleIndex !== activeIndex ? toggleIndex : null)

  const [selectorY, setSelectorY] = useState(0)
  const [scaleY, setScale] = useState(0)

  return (
    <section className="my-10 md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-g">
          <div className="col-1-type-g1">
            <h2 className="mb-11 u-h1">{heading}</h2>

            <div className="relative">
              {items.map((item, index) => (
                <HarmonicaItem
                  key={item.id}
                  item={item}
                  index={index}
                  activeIndex={activeIndex}
                  onToggle={() => handleToggle(index)}
                  onMouseLeave={() => {
                    setScale(0)
                  }}
                  onMouseEnter={el => {
                    if (activeIndex !== index) setScale(1)
                    setSelectorY(el.offsetTop)
                  }}
                />
              ))}
              <motion.span
                className="selector absolute top-0 left-0 w-full h-[69px] bg-gray-2 z-[-1]"
                animate={{ y: selectorY, scaleY }}
                transition={{
                  type: 'spring',
                  stiffness: 150,
                  bounce: 0,
                  mass: 0.1,
                  velocity: 0,
                }}
              ></motion.span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default M12Harmonica
